//@flow
import FunctionStore from '../Base/functionStoreClass';
import { updateState, reset } from '../Base/storeUtils';
import Constants from '../../constants';
import { toJSCached } from '../../Utils/immutable';

import type { HandlerAdd, StoreState } from '../Base/functionStoreClass';

export type HelloBarData = {
  text:?string,
  additionalText:?string,
  link:?string,
  renderMarkup?:boolean,
};

export default class HelloBarClass extends FunctionStore {

  _initialState(state:StoreState) {
    state.setIn(['hellobar', 'text'], null);
    state.setIn(['hellobar', 'additionalText'], null);
  }

  getData() {
    return toJSCached(this.getState().get('hellobar'));
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.SET_HELLOBAR_TEXT, updateState(_setHelloBarText));
    onSuccess(Constants.RESET_HELLOBAR_TEXT, reset);
    onSuccess(Constants.SET_ADDITIONAL_HELLOBAR_TEXT, updateState(_setAdditionalHelloBarText));
    onSuccess(Constants.SET_HELLOBAR_DATA, updateState(_setHelloBarData));
  }
}

function _setHelloBarText(state:StoreState, data:{text:string}) {
  state.setIn(['hellobar', 'text'], data.text);
}

function _setAdditionalHelloBarText(state:StoreState, data:{additionalText:string}) {
  state.setIn(['hellobar', 'additionalText'], data.additionalText);
}

function _setHelloBarData(state:StoreState, data:HelloBarData) {
  state.set('hellobar', data);
}
